import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ItemsToSellService } from 'src/app/_services';
import { PictureService } from 'src/app/_services/picture.service';
import { ListingsSearchIndexService } from '../../services/listings-search-index.service';
import { ParsingService } from '../../services/parsing.service';

@Component({
  selector: 'admin-page',
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.scss']
})
export class AdminPageComponent {

  references = new FormControl('', [Validators.required]);
  originalKey = new FormControl('', [Validators.required]);
  oldIndexName = new FormControl('', [Validators.required]);
  newIndexName = new FormControl('', [Validators.required]);
  syncAllItemsIndexName  = new FormControl('', [Validators.required]);
  itemIdToDelete = new FormControl(null, [Validators.required]);
  itemIdToDeleteFromSearch = new FormControl(null, [Validators.required]);

  constructor(private parsingService: ParsingService,
    private pictureService: PictureService,
    private listingsSearchIndexService: ListingsSearchIndexService,
    private itemsToSellService: ItemsToSellService
  ) {
  }
  
  parse() {
    
    if (!this.references.value) {
      return;
    }
    
    this.parsingService.parse(this.references.value.split(",")).subscribe();
  }
  
  parseAllFailedEmails() {
    this.parsingService.parseAllFailedEmails().subscribe();
  }
  
  async calculatePictureStats() {
    console.log(JSON.stringify(await this.pictureService.calculatePictureStats()));
  }
  
  async createIndex() {
    await this.listingsSearchIndexService.create();
  }
  
  async createNewIndex() {
    await this.listingsSearchIndexService.crateNewIndex(this.newIndexName.value!);
  }
  
  async syncAllItemsToIndex() {
    await this.listingsSearchIndexService.syncAllItemsToIndex(this.syncAllItemsIndexName.value!);
  }
  
  async deleteIndex() {
    await this.listingsSearchIndexService.deleteIndex(this.oldIndexName.value!);
  }
  
  async createThumbnail() {
    await this.pictureService.createThumbnail(this.originalKey.value!);
  }
  
  async deleteItem() {
    await this.itemsToSellService.delete(this.itemIdToDelete.value!);
  }
  
  async deleteItemFromSearch() {
    await this.listingsSearchIndexService.deleteItem(this.itemIdToDeleteFromSearch.value!);
  }
  
  async triggerItemToSellCategoryCodesMigration() {
    await this.itemsToSellService.triggerCategoryCodesMigration();
  }
}